export default function ContentLayout({ children }) {
  return (
    <div className="px-2 md:px-28 lg:px-32  2xl:px-72 flex flex-col gap-2">
      {children}
    </div>
  );
}
